import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const UnhappyFaceIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 15.7305C11.866 15.7305 15 12.5965 15 8.73053C15 4.86454 11.866 1.73053 8 1.73053C4.13401 1.73053 1 4.86454 1 8.73053C1 12.5965 4.13401 15.7305 8 15.7305ZM5.84164 11.9013C5.6564 12.2718 5.20589 12.422 4.83541 12.2367C4.46493 12.0515 4.31476 11.601 4.5 11.2305C4.76397 10.7026 5.82582 9.31594 8.17082 9.31594C10.5158 9.31594 11.5777 10.7026 11.8416 11.2305C12.0269 11.601 11.8767 12.0515 11.5062 12.2367C11.1357 12.422 10.6852 12.2718 10.5 11.9013C10.4306 11.7626 9.82582 10.8159 8.17082 10.8159C6.51582 10.8159 5.91101 11.7626 5.84164 11.9013ZM5 6.73053C5 6.17825 5.44772 5.73053 6 5.73053C6.55228 5.73053 7 6.17825 7 6.73053V7.23053C7 7.50667 6.77614 7.73053 6.5 7.73053H5.5C5.22386 7.73053 5 7.50667 5 7.23053V6.73053ZM10 5.73053C9.44771 5.73053 9 6.17825 9 6.73053V7.23053C9 7.50667 9.22386 7.73053 9.5 7.73053H10.5C10.7761 7.73053 11 7.50667 11 7.23053V6.73053C11 6.17825 10.5523 5.73053 10 5.73053Z"
			/>
		</svg>
	),
)
